/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Cancellation_ReasonInputs */

const en_task_cancellation_reason = /** @type {(inputs: Task_Cancellation_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation reason`)
};

const pt_br2_task_cancellation_reason = /** @type {(inputs: Task_Cancellation_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivo do cancelamento`)
};

/**
* | output |
* | --- |
* | "Cancellation reason" |
*
* @param {Task_Cancellation_ReasonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_cancellation_reason = /** @type {((inputs?: Task_Cancellation_ReasonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Cancellation_ReasonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_cancellation_reason(inputs)
	return pt_br2_task_cancellation_reason(inputs)
});